import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface CrownIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const CrownIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: CrownIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M3 11.2491C3 9.71045 5.00645 9.12115 5.8385 10.4154V10.4154C6.5244 11.4824 8.13347 11.3107 8.57884 10.1231L10.1273 5.99375C10.7762 4.26342 13.2238 4.26342 13.8727 5.99376L15.4212 10.1231C15.8665 11.3107 17.4756 11.4824 18.1615 10.4154V10.4154C18.9935 9.12115 21 9.71045 21 11.2491V16C21 17.1046 20.1046 18 19 18H5C3.89543 18 3 17.1046 3 16V11.2491Z"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M11.6106 10.5096C11.7144 10.1073 12.2856 10.1073 12.3894 10.5095L12.761 11.9501C12.7975 12.0918 12.9082 12.2025 13.0499 12.239L14.4904 12.6106C14.8927 12.7144 14.8927 13.2856 14.4905 13.3894L13.0499 13.761C12.9082 13.7975 12.7975 13.9082 12.761 14.0499L12.3894 15.4904C12.2856 15.8927 11.7144 15.8927 11.6106 15.4905L11.239 14.0499C11.2025 13.9082 11.0918 13.7975 10.9501 13.761L9.50955 13.3894C9.10729 13.2856 9.10728 12.7144 9.50955 12.6106L10.9501 12.239C11.0918 12.2025 11.2025 12.0918 11.239 11.9501L11.6106 10.5096Z"
                fill={color}
            />
        </svg>
    )
}

export default CrownIcon
